<template>
<div class="makeProcess layerpopup" :class="{'active': visibility}">
  <div class="contentWrap">
    <h2 class="title"> {{
        title
      }} </h2>
    <div class="content">
      <h3>분류</h3>
      <div class="field">
        <FieldSelector v-for="(field, index) of fieldSelected" placeholder="분야를 선택해 주세요" 
          :options="field"
          @dataChange="(item)=>changeField(item, index)"
          :data-valid="!fieldValues[index] ? true: false"
          :selected="fieldValues[index] ? fieldValues[index] : 0"
          :disabled="fieldEditFlag"
          :publicFlag="publicFlag"
        ></FieldSelector>
      </div>
      <h3>기술분류</h3>
      <div class="field">
        <FieldSelector v-for="(knscc, index) of knsccSelected" placeholder="국가과학기술표준분류를 선택해 주세요" 
          :options="knscc"
          @dataChange="(item)=>changeKnscc(item, index)"
          :data-valid="!knsccValues[index] ? true: false"
          :selected="knsccValues[index] ? knsccValues[index] : 0"
          :disabled="knsccEditFlag"
          :publicFlag="publicFlag"
        ></FieldSelector>
      </div>
      <!-- 프로토콜 생성시에만 unit full 선택 가능하도록 수정. -->
      <div v-if="this.projectType === 'protocol' && this.actionType == 'make' && this.onlyProtocolFlag" class="fieldType">
        <h3>구분선택</h3>
        <label><input type="radio" name="fiedType" value="FULL" v-model="checkType"> <span>Full</span> </label>
        <label><input type="radio" name="fiedType" value="UNIT" v-model="checkType"> <span>Unit</span> </label>
      </div>
      <div v-if="checkType=='UNIT' && Type === 'protocol|make'" class="fieldType">
        <h3>유닛선택</h3>
        <NodeSelector @change="(item)=>selectParentNode(item)" :parentNodes="parentNodes"></NodeSelector>
      </div>
      <div class="processName">
        <h3>{{ (this.projectType == 'process' ? '공정도' : '프로토콜') }}명</h3>
        <div>
          <h4>국문</h4>
          <div class="editor" :data-valid="(this.titleKR === false) ? true: false">
            <editor-content :editor="textEditorKR" />
          </div>
          <button @click="textEditorKR.chain().focus().toggleSuperscript().run()">위<br>첨자</button>
          <button @click="textEditorKR.chain().focus().toggleSubscript().run()">아래<br>첨자</button>
        </div>
        <div>
          <h4>영문</h4>
          <div class="editor" :data-valid="(this.titleEN === false) ? true: false">
            <editor-content :editor="textEditorEN" />
          </div>
          <button @click="textEditorEN.chain().focus().toggleSuperscript().run()">위<br>첨자</button>
          <button @click="textEditorEN.chain().focus().toggleSubscript().run()">아래<br>첨자</button>
        </div>
      </div>
    </div>
    <div class="ctrl">
      <button v-if="this.actionType == 'make'" class="confirm" @click="confirm">생성하기</button>
      <button v-else class="confirm" @click="confirm">수정하기</button>
    </div>
    <button class="close" @click="closePopup">닫기</button>
  </div>
  <Loading :visible="loading"/>
</div>
</template>

<script>
import {Editor, EditorContent} from '@tiptap/vue-2';
import StarterKit from "@tiptap/starter-kit";
import Superscript from '@tiptap/extension-superscript'
import Subscript from '@tiptap/extension-subscript'
import FieldSelector from '@common/selects/MakeProcessSelector';
import TargetSelector from '@common/selects/TargetSelector';
import NodeSelector from '@common/selects/NodeSelector';
import Loading from "@/components/common/loading.vue";

export default {
  props: {
    Type: {
      // type: Object, default: function() { return {projectType: 'process', actionType:'make'}}
      type: String, default: 'process|make'
    },
    active: {
      type: Boolean, default: false
    },
    selectTemplateData:{
      type : Object, default : function(){ return {} }
    },
    Data: {
      type: Object, default: function() { return {} }
    },
    onlyProtocolFlag: {
      type: Boolean, default: false
    }
  },
    data() {
    return {
      visibility: false,
      editorFocus: false,
      editorBlurTimer: null,
      textEditorKR: null,
      textEditorEN: null,
      projectType: false,
      actionType: false,
      fieldDatas: null,
      knsccDatas: null,
      fieldSelected:[],
      knsccSelected:[],
      fieldValues:[],
      knsccValues:[],
      selectedFieldId: null,
      selectedKnsccId: null,
      titleKR: null,
      titleEN: null,
      checkType: null,

      fullField:[],
      fullKnscc:[],
      // 채번 생성을 위해서 unit의 경우에도 full과 동일하게 분류와 기순분류를 모두 전달 받도록 수정.
      // unitField:[[]],

      parentNodes : [],
      selectNode : null,
      fieldEditFlag: false,
      knsccEditFlag: false,
      publicFlag: false,
      loading: false,
    }
  },
  components: { EditorContent, FieldSelector, TargetSelector, NodeSelector, Loading },
  watch: {
    active: async function (value) {
      this.visibility = value;
      if (this.Type == 'protocol|make' && this.$route.query.processId && value) {
        this.fieldEditFlag = true;
        this.knsccEditFlag = true;
        this.setFieldAndKnscc();
      }else if ( ["protocol|edit", "process|edit"].includes(this.Type) && this.$route.query.processId && value ) {
        try {
          let detail = await this.$wApi.process.detail(null, this.$route.query.processId);
          if(detail && detail?.publicActive > 0){
            this.fieldEditFlag = true;
            this.knsccEditFlag = true;
            this.publicFlag = true;
          }
        }catch (e) {
          this.fieldEditFlag = true;
          this.knsccEditFlag = true;
          window.alert("로딩중 오류가 발생했습니다. <br>관리자에게 문의해 주세요.");
        }
      }
    },
    Data: function (value) {
      if(this.Type === 'process|edit') {
        this.getProcess();
      } else if(this.Type === 'protocol|edit') {
        this.getProtocol();
      }
    },
    checkType : function(value){
      if( value == 'UNIT' && this.Type == 'protocol|make' ){
        console.log( "this.selectTemplateData", this.selectTemplateData )
        if( this.selectTemplateData.content ){
          const json = JSON.parse(this.selectTemplateData.content);
          this.parentNodes = json.issues.filter(o=>o.P === true && o.isWriter === undefined && o.isProcess === undefined && o.isKeyword === undefined );
          // console.log( "this.parentNodes" , this.parentNodes )
          // this.parentNodes
        }
        
      }

      // if( value == 'UNIT' ){
      //   this.fieldSelected = this.unitField;
      //   this.knsccSelected = [];
      // }else{
      //   this.fieldSelected = this.fullField;
      //   this.knsccSelected = this.fullKnscc;
      // }
    }
  },
  computed: {
    title() {
      return (this.projectType == 'process' ? '공정도' : '프로토콜') + (this.actionType == 'make' ? ' 생성' : ' 정보수정')
    },
  }, 
  async mounted() {
    let type = this.Type.split('|');
    let detail;
    this.projectType = type[0];
    this.actionType = type[1];
    this.textEditorKR = new Editor({
			editable: true,
			extensions: [ StarterKit,Superscript,Subscript],
      onUpdate: ({editor})=> {
        this.titleKR = editor.getHTML();
        // this.titleKR = editor.getText();
      }
		});
    this.textEditorEN = new Editor({
			// content: ' ',
			editable: true,
			extensions: [ StarterKit,Superscript,Subscript],
      onUpdate: ({editor})=> {
        this.titleEN = editor.getHTML();
        // this.titleEN = editor.getText();
      }
		});
    this.fieldDatas = await this.$wApi.field.gets();
    this.knsccDatas = await this.$wApi.knscc.gets();
    this.fullField = [this.fieldCheck(this.fieldDatas)];
    this.fullKnscc = [this.knsccCheck(this.knsccDatas)];
    // for( let field of this.fullField[0] ){
    //   let cloneField = JSON.parse(JSON.stringify(field));
    //   cloneField.sub = [];
    //   this.unitField[0].push(cloneField);
    // }
    // this.fieldSelected = [this.fieldCheck(this.fieldDatas)];
    if(this.actionType == 'make'){
      this.fieldSelected = this.fullField;
      this.knsccSelected = this.fullKnscc;
    }
  },
  methods: {
    selectParentNode(item){
      this.selectNode = null;
      if( item.value === '' || !item ){
        return;
      }
      this.selectNode = item.value;
      // console.log("this.selectTemplateData", this.selectTemplateData )
      if( typeof this.selectTemplateData.content === 'string' ){
        this.selectTemplateData.content = JSON.parse(this.selectTemplateData.content);
      }
      if( typeof this.selectTemplateData.content === 'string' ){
        this.selectTemplateData.content = JSON.parse(this.selectTemplateData.content);
      }
      // console.log( "item", item )
      const parentChildMap = {};
      for (const item of this.selectTemplateData.content.issues) {
          const parent = item.parent;
          const key = item.key;
          if (!parentChildMap[parent]) {
              parentChildMap[parent] = [];
          }
          parentChildMap[parent].push(key);
      }

      function findAllChildrenKeys(key) {
          let childrenKeys = [];
          const children = parentChildMap[key];
          if (children) {
              for (const child of children) {
                  childrenKeys.push(child);
                  childrenKeys = childrenKeys.concat(findAllChildrenKeys(child));
              }
          }
          return childrenKeys;
      }

      // 3. key 값이 1인 데이터와 해당 데이터의 모든 자식 key 값을 추출
      const connectedKeys = [item.value];
      const childrenKeys = findAllChildrenKeys(item.value);
      connectedKeys.push(...childrenKeys);

      // 4. connectedKeys에 포함되지 않은 데이터 필터링
      // console.log( "before", this.selectTemplateData.content.issues );
      const filterData = this.selectTemplateData.content.issues.filter(item => connectedKeys.includes(item.key));
      const resData = JSON.stringify({issues : filterData});
      // console.log( "resData", resData );
      this.$emit('tempChange', resData);      
    },
    changeField(field, index) {
      // 이미 Selected,Values에 값이 존재하는경우 현재 선택된 다음 index를 삭제하는 loop.
      // 이후 하위 로직을 타면서 현재 선택된 데이터에 맞게 하위 value를 setting한다.
      for ( let i = index+1; i < this.fieldSelected.length; i++ ){
          this.fieldSelected.splice(i,1);
          this.fieldValues.splice(i,1);
      }
      let newField = this.fieldSelected.slice();
      let newValues = this.fieldValues.slice();
      newValues[index] = field.value;
      this.fieldValues = newValues;
      if(!field.option.sub || field.option.sub.length === 0) {
        this.selectedFieldId = field.field
        return
      };
      newField[index+1] = this.fieldCheck(field.option.sub);
      this.fieldSelected = newField;
      this.selectedFieldId = null;
    },
    changeKnscc(knscc, index) {
      // 이미 Selected,Values에 값이 존재하는경우 현재 선택된 다음 index를 삭제하는 loop.
      // 이후 하위 로직을 타면서 현재 선택된 데이터에 맞게 하위 value를 setting한다.
      for ( let i = index+1; i < this.knsccSelected.length; i++ ){
          this.knsccSelected.splice(i,1);
          this.knsccValues.splice(i,1);
      }
      let newKnscc = this.knsccSelected.slice();
      let newValues = this.knsccValues.slice();
      newValues[index] = knscc.value;
      this.knsccValues = newValues;
      if(!knscc.option.sub || knscc.option.sub.length === 0) {
        this.selectedKnsccId = knscc.knsccId
        return
      };
      newKnscc[index+1] = this.knsccCheck(knscc.option.sub);
      this.knsccSelected = newKnscc;
      this.selectedKnsccId = null;
    },
    async getProcess() {
      let detail
      if(this.Data) {
        detail = this.Data;
      } else {
        detail = await this.$wApi.process.detail(null, this.$route.query.processId);
      }
      if(detail.fieldId) this.checkFieldOption(detail.fieldId);
      if(detail.knsccId) this.checkKnsccOption(detail.knsccId);
      this.textEditorKR.commands.setContent(detail.processName);
      this.textEditorEN.commands.setContent(detail.processEngName);
      this.titleKR = detail.processName;
      this.titleEN = detail.processEngName;
      // knsccId은 필수값인데 존재하지 않는다면 make와 동일하게 사용자가 선택해야되도록 수정.
      if(!detail.knsccId){
        this.knsccSelected = [this.knsccCheck(await this.$wApi.knscc.gets())];  
      }
      return detail;
    },
    async getProtocol() {
      let detail
      if(this.Data) {
        detail = this.Data;
      } else {
        const Protocols = await this.$wApi.protocol.gets({
          processId: this.$route.query.processId,
          isMemo: false,
          isConent: false,
          isComment: false,
        });
        detail = Protocols.filter( p => p.id == this.$route.query.protocolId )[0] ; 
      }
      if(detail.fieldId) this.checkFieldOption(detail.fieldId);
      if(detail.knsccId) this.checkKnsccOption(detail.knsccId);
      this.textEditorKR.commands.setContent(detail.name);
      this.textEditorEN.commands.setContent(detail.nameEng);
      this.titleKR = detail.name;
      this.titleEN = detail.nameEng;
      this.checkType = detail.protocolType;

      // if( this.checkType === 'UNIT' ) this.fieldSelected = this.unitField;
    },
    async setFieldAndKnscc() {
      this.loading = true;
      let detail = await this.$wApi.process.detail(null, this.$route.query.processId);
      if(detail.fieldId) {
        await this.checkFieldOption(detail.fieldId)
      };
      if(detail.knsccId) {
        await this.checkKnsccOption(detail.knsccId)
      };
      // knsccId은 필수값인데 존재하지 않는다면 make와 동일하게 사용자가 선택해야되도록 수정.
      if(!detail.knsccId){
        this.knsccSelected = [this.knsccCheck(await this.$wApi.knscc.gets())];  
      }
      this.loading = false;
    },
    async checkFieldOption(fieldIds) {
      let index = 0;
      let allFieldData = await this.$wApi.field.gets();
      let fieldData = allFieldData.slice();
      fieldIds = fieldIds.split('>');
      this.fieldSelected = [];
      async function findField(id, data) {
        for(let field of data) {
          if(field.fieldId === id) {
            field.select=true 
            return field.subField
          }
        }
      }

      for(let id of fieldIds) {
        id = Number(id);
        let sub = await findField(id, fieldData);
        if(!sub) break;
        this.fieldSelected.push(this.fieldCheck(fieldData));
        this.fieldValues[index] = id;
        fieldData = sub;
        index++
      }

    },

    async checkKnsccOption(knsccIds) {
      let index = 0;
      let allKnsccData = await this.$wApi.knscc.gets();
      let knsccData = allKnsccData.slice();
      knsccIds = knsccIds.toString().split('>');
      this.knsccSelected = [];
      async function findKnscc(id, data) {
        for(let knscc of data) {
          if(knscc.knsccId === id) {
            knscc.select=true
            return knscc.subKnscc
          }
        }
      }
      for(let id of knsccIds) {
        id = Number(id);
        let sub = await findKnscc(id, knsccData);
        if(!sub) break;
        this.knsccSelected.push(this.knsccCheck(knsccData));
        this.knsccValues[index] = id;
        knsccData = sub;
        index++
      }
    },
    confirm() {
      let status = true;
      function titleCheck(title) {
        return (!title || title === '' || title === '<p></p>' || title == null ) ? false : title
      }
      this.titleKR = titleCheck(this.titleKR);
      this.titleEN = titleCheck(this.titleEN);

      let requestKnscc = {
        // 과학기술분류 
        knsccId: "",
        // 과학기술표준분류코드 
        knsccCode: "",
        // 과학기술표준분류명 
        knsccCodeName: "",
      };
      let requestField = {
        // 대분류코드 
        categoryLargeCode: "",
        // 대분류명 
        categoryLargeCodeName: "",
        // 중분류코드 
        categoryMiddleCode: "",
        // 중분류명 
        categoryMiddleCodeName: "",
        // 소분류코드(공정식별번호) 
        categorySmallCode: "",
        // 소분류코드명 
        categorySmallCodeName: "",
        // 소소분류코드(하부공정식별번호) 
        categoryMicroCode: "",
        // 소소분류코드명 
        categoryMicroCodeName: "",
      };

      status = this.titleKR && this.titleEN;
      // 필수값이 false일때 함수종료 => 하위에서 true로 변환되어 정상처리되지 않도록 수정.
      if(!status){
        window.alert("필수 입력값을 입력해주세요.");
        return;
      }

      for(let i=0; i<this.fieldValues.length; i++) {
        this.fieldValues[i] = !this.fieldValues[i] ? false : this.fieldValues[i];
        status = status && this.fieldValues[i];
      }
      // 필수값이 false일때 함수종료 => 하위에서 true로 변환되어 정상처리되지 않도록 수정.
      if(!status){
        window.alert("필수 입력값을 입력해주세요.");
        return;
      }
      
      for(let i=0; i<this.knsccValues.length; i++) {
        this.knsccValues[i] = !this.knsccValues[i] ? false : this.knsccValues[i];
        status = status && this.knsccValues[i];
      }
      // 필수값이 false일때 함수종료 => 하위에서 true로 변환되어 정상처리되지 않도록 수정.
      if(!status){
        window.alert("필수 입력값을 입력해주세요.");
        return;
      }
      
      // selectBox 개수와 선택된 데이터 개수가 동일한지 확인하여 필수 데이터가 모두 입력되었는지 확인.
      status = this.fieldSelected.length == this.fieldValues.length && this.knsccSelected.length == this.knsccValues.length;
      // 필수값이 false일때 함수종료 => 하위에서 true로 변환되어 정상처리되지 않도록 수정.
      if(!status){
        window.alert("필수 입력값을 입력해주세요.");
        return;
      }

      // 대, 중, 소, 기술분류 데이터를 넣어줌.
      if(status){
        this.fieldSelected.forEach((data,index)=>{
            data.forEach((obj)=>{
              for( let value of this.fieldValues ) {
                if(obj.value == value){
                  switch (index) {
                    case 0 : //대분류
                      // 대분류코드
                      requestField.categoryLargeCode = obj.code;
                      // 대분류명
                      requestField.categoryLargeCodeName = obj.label;
                      break;
                    case 1 : //중분류
                      // 중분류코드 
                      requestField.categoryMiddleCode = obj.code;
                      // 중분류명 
                      requestField.categoryMiddleCodeName = obj.label;
                      break;
                    case 2 : //소분류
                      // 소분류코드(공정식별번호) 
                      requestField.categorySmallCode = obj.code;
                      // 소분류코드명 
                      requestField.categorySmallCodeName = obj.label;
                      break;
                    case 3 : //소소분류
                      // 소소분류코드(하부공정식별번호) 
                      requestField.categoryMicroCode = obj.code;
                      // 소소분류코드명 
                      requestField.categoryMicroCodeName = obj.label;
                      break;
                  }
                };
              }
            })
        });

        this.knsccSelected.forEach((data, index) => {
          data.forEach((obj) => {
              if (obj.value == this.knsccValues[this.knsccValues.length-1]) {
                  // 과학기술분류
                  requestKnscc.knsccId = obj.value;
                  // 과학기술표준분류코드
                  requestKnscc.knsccCode = obj.code;
                  // 과학기술표준분류명
                  requestKnscc.knsccCodeName = obj.label;
              }
          })
        });
      }
      
      if( this.projectType === 'protocol' && this.onlyProtocolFlag ){
        status = this.checkType != null;
      }
      // 필수값이 false일때 함수종료 => 하위에서 true로 변환되어 정상처리되지 않도록 수정.
      if(!status){
        window.alert("필수 입력값을 입력해주세요.");
        return;
      }

      if( this.checkType === 'UNIT' && this.Type === 'protocol|make' ){
        status = this.selectNode !== null;
      }
      
      if(status) {
        this.$emit('confirm', {
          kr : this.titleKR,
          en : this.titleEN,
          field: this.fieldValues,
          requestField : requestField,
          requestKnscc : requestKnscc,
          type: this.checkType
        });
      }else{
        window.alert("필수 입력값을 입력해주세요.")
      }
    },
    fieldCheck(fields) {
      let newField = [], index = 0
      ;
      for(const field of fields) {
        newField[index] = {
          value: field.fieldId,
          code: field.code,
          label: field.name,
          sub: field.subField,
          select: field.select ? field.select : false
        }
        index++;
      }

      return newField;
    },
    knsccCheck(knsccs) {
      let newKnscc = [], index = 0
      ;
      for(const knscc of knsccs) {
        newKnscc[index] = {
          value:  knscc.knsccId,
          code:  knscc.code,
          label:  knscc.name+`(${knscc.code})`,
          sub:    knscc.subKnscc,
          select: knscc.select ? knscc.select : false
        }
        index++;
      }

      return newKnscc;
    },
    closePopup() {
      this.visibility = false
      this.$emit('close', this.visibility);
    },
    selectField(field, step=0) {
      this.fieldSelected[step]
    },
  }
}
</script>

<style lang="scss" scoped>
.makeProcess {
  @include modalLayoutBlur;
  @include text-prt;
  
  .contentWrap {
    min-width: 800px;
    background: rgb(239,246,255);
    background: linear-gradient(180deg, rgba(239,246,255,1) 72px, rgba(255,255,255,1) 72px);
    >.title {
      min-height: 42px
    }
    >.content {
      overflow: visible;
      h3:nth-of-type(1) {
        margin-bottom: 7px;
        font-size: 16px;
      }
      h3:nth-of-type(2) {
        margin-top: 15px;
        margin-bottom: 7px;
        font-size: 16px;
      }
    }
    .ctrl {
      margin-top: 24px;
    }
    
    .field {
      display: flex; justify-content: space-between;
      gap: 8px;
      
      .data-select {
        width: 100%; height: 35px;
        border: 1px solid #999;
        z-index: 1;
        .type-select {
          background: #ddd;
          option { font-size: 14px !important}
        }
        &[data-valid='true'] {
          border-color: red;
        }
      }
      select {
        width: 100%;
        padding: 8px;
        border: 1px solid #999;
        &:required:invalid {
          color: #ccc;
        }
        option {
          padding: 8px 16px;
        }
      }
    }
    .fieldType {
      display: flex; gap: 12px;
      align-items: center;
      margin-top: 16px;
      h3 { font-size: 14px; font-weight: 500; }
      label {
        display: inline-flex;
        input { visibility: hidden; width: 0; height: 0; 
          &:checked + span {
            color: #333;
            &::before {
              border-color: #333;
              background: rgb(51,51,51);
              background: radial-gradient(circle, rgba(51,51,51,1) 40%, rgba(255,255,255,1) 50%);
            }
          }
        }
        span { display: flex; gap: 8px;
          font-size: 16px; color: #999;
          &::before {
            content: '';
            display: block; width: 13px; height: 13px;
            border: 1px solid #999; border-radius: 50%;
          }
        }
      }
    }
    .processName {
      margin-top: 24px;
      h3 {
        font-size: 16px;
      }
      > div {
        margin-top: 8px;
        display: flex;
        h4 {
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
          min-width: 56px;
          margin-right: 8px;
        }
        button {
          flex-shrink: 0;
          display: flex; align-items: center; justify-content: center;
          width: 36px;
          border: 1px solid #999;
          margin-left: -1px;
          font-size: 12px;
        }
        .editor {
          // display: flex; align-items: center;
          width: 100%;
          min-height: 36px;
          border: 1px solid #999;
          padding: 8px 16px;

          &[data-valid="true"] {
             border-color: red; 
          }
        }
      }
    }
  }
  button.confirm, button.edit { 
    @include btn-confirm;
  }
}
</style>